import styled from "styled-components"
import { resetButton, respondAbove } from "styles/mixins"
import TypographyPro from "themes/TypographyPro"
import CloseIcon from '@material-ui/icons/Close'
import { ArrowBackIos as ArrowBack } from '@material-ui/icons'

export const StyledOrderTypeSelectionContainer = styled.div`
	padding: 1.25rem 1.25rem 0 1.25rem;

	${respondAbove.lg`
    	padding: 1.75rem 1.75rem 0 1.75rem;
	`}
`

export const StyledOrderTypeSelectionTitle = styled(TypographyPro)`
	color: var(--strokeMenuTitle);
`

export const StyledCloseIcon = styled(CloseIcon)`
	color: var(--inactive);
	height: 1.25rem;
	width: 1.25rem;
`

export const StyledCloseButton = styled.button`
  ${resetButton}
  display: flex;
	height: fit-content;
	cursor: pointer;
`

export const StyledArrowBack = styled(ArrowBack)`
  cursor: pointer;
	color: var(--inactive);
	font-size: 15px;
`

export const StyledOrderTypesContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1.25rem;

	${respondAbove.lg`
    	gap: 1.75rem;
	`}
`